export default __webpack_public_path__ + "static/media/gbarbosa.7bd84942.jpg";